import { render } from "./ReportAccidentUnauth.vue?vue&type=template&id=690a7528"
import script from "./ReportAccidentUnauth.vue?vue&type=script&lang=js"
export * from "./ReportAccidentUnauth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__